export const black = '#000000';
export const white = '#ffffff';
// Mercedes-Benz Brand Colors
export const grey = {
    [95]: '#F8F8F8',
    [90]: '#F4F4F4',
    [85]: '#E8E8E8',
    [80]: '#DBDBDB',
    [75]: '#C9C9C9',
    [70]: '#BBBBBB',
    [65]: '#ADADAD',
    [60]: '#9F9F9F',
    [55]: '#919191',
    [50]: '#848484',
    [45]: '#767676',
    [40]: '#696969',
    [35]: '#5C5C5C',
    [30]: '#4F4F4F',
    [25]: '#424242',
    [20]: '#333333',
    [15]: '#262626',
    [10]: '#1A1A1A',
    [5]: '#0D0D0D',
};
export const blue = {
    [95]: '#E6F5FF',
    [90]: '#CCE8FF',
    [85]: '#B4DDFE',
    [80]: '#9AD2FE',
    [75]: '#80C6FF',
    [70]: '#66BBFD',
    [65]: '#4EAFFD',
    [60]: '#33A4FD',
    [55]: '#1998FC',
    [50]: '#008DFC',
    [45]: '#0078D6',
    [40]: '#036DC1',
    [35]: '#0260AB',
    [30]: '#025497',
    [25]: '#014880',
    [20]: '#013C6B',
    [15]: '#003156',
    [10]: '#002441',
    [5]: '#00182C',
};
export const red = {
    [95]: '#FFEDED',
    [90]: '#FFDBDB',
    [85]: '#FFC9C9',
    [80]: '#FFB7B7',
    [75]: '#FFA5A5',
    [70]: '#FF9292',
    [65]: '#FF8080',
    [60]: '#FF6E6E',
    [55]: '#FF5C5C',
    [50]: '#FF4A4A',
    [45]: '#D92121',
    [40]: '#C31E1E',
    [35]: '#AE1A1A',
    [30]: '#981717',
    [25]: '#821414',
    [20]: '#6D1111',
    [15]: '#570D0D',
    [10]: '#410A0A',
    [5]: '#2B0707',
};
export const green = {
    [95]: '#E9F6EA',
    [90]: '#D3EDD6',
    [85]: '#BCE3C1',
    [80]: '#A6DAAC',
    [75]: '#90D198',
    [70]: '#7AC883',
    [65]: '#64BF6E',
    [60]: '#4DB559',
    [55]: '#37AC45',
    [50]: '#21A330',
    [45]: '#198025',
    [40]: '#177321',
    [35]: '#14661E',
    [30]: '#125A1A',
    [25]: '#0F4D16',
    [20]: '#0D4013',
    [15]: '#0A330F',
    [10]: '#07260B',
    [5]: '#051A07',
};
export const yellow = {
    [95]: '#FFFAE6',
    [90]: '#FEF5CC',
    [85]: '#FEF0B3',
    [80]: '#FDEB99',
    [75]: '#FDE680',
    [70]: '#FCE066',
    [65]: '#FCDB4C',
    [60]: '#FBD633',
    [55]: '#FBD11A',
    [50]: '#FACC00',
    [45]: '#E8BD00',
    [40]: '#D1AA00',
    [35]: '#BA9700',
    [30]: '#A28400',
    [25]: '#8B7100',
    [20]: '#745F00',
    [15]: '#5D4C00',
    [10]: '#463900',
    [5]: '#2E2600',
};
// Mercedes-Benz Brand Data Visualization Colors
export const dataVisColors = {
    basic: {
        light: [blue[45], blue[5], blue[25], blue[55], blue[65], blue[75], blue[85]],
        dark: [blue[50], blue[95], blue[85], blue[75], blue[65], blue[40], blue[30]],
    },
    extended: {
        light: [
            '#522099',
            blue[55],
            '#125D5D',
            '#991844',
            red[50],
            '#660F0F',
            green[50],
            blue[40],
            '#FC5895',
            '#B38000',
            '#1FA3A3',
            blue[15],
            '#C23E15',
            '#7C30E6',
        ],
        dark: [
            '#8333F2',
            blue[65],
            '#198585',
            '#CC215A',
            red[50],
            red[95],
            green[70],
            blue[45],
            '#FC5895',
            '#F7B100',
            '#2EF0F0',
            blue[80],
            '#FF8442',
            '#8371F0',
        ],
    },
    special: {
        light: {
            lightgrey: grey[45],
            darkgrey: grey[30],
            success: green[45],
            warning: yellow[45],
            error: red[45],
        },
        dark: {
            lightgrey: grey[70],
            darkgrey: grey[55],
            success: green[50],
            warning: yellow[50],
            error: red[50],
        },
    },
};
